import React from 'react';
import logo from '../../images/sport/generic/Logo.svg';
import RemoteImage from '../remote_img/remote_img';
import { SPORT_LIST } from '../../javascript/services/globalVars';
import useIsLandscape from '../../javascript/utils/use-is-landscape.js';
import style from './logo-sport-style.module.scss';

function LogoSport(Props) {
   const isLandscape = useIsLandscape();
   const sport = Props.sport;
   const sport_obj = SPORT_LIST.find(i => i.id === sport);
   const logo_image = typeof sport_obj !== 'undefined'?  sport_obj.image : logo;
   const sport_logo = logo_image.replace('/sportIcons/', '/SVGIcons/').replace('.png', '.svg')
   
   return (
      <div className={style.logoSport} data-orientation={isLandscape ? 'landscape' : 'portrait'}>
         <RemoteImage className={style.logoSportImg} src={sport_logo} alt="logo"></RemoteImage>
      </div>
   );
}

export default LogoSport;